import TimeMaker from './timemaker';
import JsDate from './timeago';
const $JQuery = jQuery;

export { TimeMaker, JsDate, $JQuery };
